export default function($) {
  $('.form-input.form-error[required]').attr('aria-invalid', 'true');
}
